export class Qualiopi {
  public OrganismText: string;
  //#region Contact
  public Adress: string;
  public TelNum: string;
  public Info: string;
  public FacebookLink: string;
  public TwitterLink: string;
  public LinkedinLink: string;
  public ViadeoLink: string;
  public YoutubeLink: string;
  public InstagramLink: string;
  //#endregion
  //#region Qualiopi
  public StatQualiopi1: string;
  public LabelQualiopi1: string;
  public StatQualiopi2: string;
  public LabelQualiopi2: string;
  public StatQualiopi3: string;
  public LabelQualiopi3: string;
  public IconQualiopi1: string;
  public IconQualiopi2: string;
  public IconQualiopi3: string;
  //#endregion

  constructor()
  {
    this.OrganismText = '';
    this.Adress = '';
    this.TelNum = '';
    this.Info = '';
  }
}
